import React from "react";
import './Card_info_curso.css';
import { makeStyles } from '@material-ui/core/styles';
import Avatar from '@material-ui/core/Avatar';
import { Image } from 'semantic-ui-react';

const useStyles = makeStyles((theme) => ({
    root: {
        width: "350px",
        height: "60px",
        backgroundColor: "transparent",
        marginBottom: "10px",
        boxSizing: "border-box",
	    display: "flex",
        // padding: "10px",
        alignItems: "center",
      },
      icon: {
        width: "40px",
        height: "40px",
        marginLeft: "10px",
      }
  }));

function Card_info_curso (props: { icono: string | undefined; title: boolean | React.ReactChild | React.ReactFragment | React.ReactPortal | null | undefined; des: boolean | React.ReactChild | React.ReactFragment | React.ReactPortal | null | undefined; }){
    const classes = useStyles();
    return(
        <div className={classes.root}>
            <Image src={props.icono} circular style={{width:"60px", height:"60px"}}/>
            <div className="contenedor_infor">
                <p className="titulo_card_curso">{props.title}</p>
                <p>{props.des}</p>
            </div>
        </div>
    );
}

export default Card_info_curso;